import { Injectable } from '@angular/core';

/**
 * Service zur Steuerung des Splash-Screens.
 *
 * Der Splash-Screen selbst wird in der `index.html` als reines HTML/CSS/JS definiert
 * (läuft vor Angular-Bootstrap). Dieser Service kapselt die globale JS-API
 * (`window.hideSplashScreen`, `window.updateSplashStatus`) für typsicheren Zugriff
 * aus Angular-Komponenten und -Services.
 *
 * Nutzung: Einfach per `inject(SplashScreenService)` einbinden.
 * Die Methoden sind No-Ops wenn kein Splash-Screen vorhanden oder SSR aktiv.
 */
@Injectable({
	providedIn: 'root'
})
export class SplashScreenService {
	/**
	 * Aktualisiert den Statustext im Splash-Screen.
	 */
	updateStatus(text: string): void {
		if (typeof window !== 'undefined' && (window as any).updateSplashStatus) {
			(window as any).updateSplashStatus(text);
		}
	}

	/**
	 * Blendet den Splash-Screen aus (mit Fade-Animation).
	 */
	hide(): void {
		if (typeof window !== 'undefined' && (window as any).hideSplashScreen) {
			(window as any).hideSplashScreen();
		}
	}
}
